import request from '@/utils/request'
// 获取父产品详细
export function parentDetail(id) {
  return request({
    url: '/product/parent/' + id,
    method: 'get'
  })
}

// 删除父产品
export function parentDelete(id) {
  return request({
    url: '/product/parent/' + id,
    method: 'post'
  })
}


// 新增父产品
export function parentAdd(data) {
  return request({
    url: '/product/parent/add',
    method: 'post',
    data: data
  })
}

// 编辑父产品
export function parentEdit(data) {
  return request({
    url: '/product/parent/edit',
    method: 'post',
    data: data
  })
}

// 获取父产品列表
export function parentList(data) {
  return request({
    url: '/product/parent/list',
    params: {
      pageNum: data.pageNum,
      pageSize: data.pageSize,
      name: data.name,
      packageName: data.packageName,
      isAsc: "desc",
      orderByColumn: "createTime"
    },
    method: 'get'
  })
}

// 用户角色年龄分页查询
export function userAgeList(data) {
  var _url = '/product/parent/userAgeList?',
  _arr = [];
  for(var key in data){
    _arr.push(key+'='+data[key])
  }
  _url+=_arr.join('&');
  return request({
    url: _url,
    method: 'get'
  })
}

// 用户角色年龄更新
export function editUserAge(data) {
  var _url = '/product/parent/editUserAge'
  return request({
    url: _url,
    method: 'post',
    data:data
  })
}

export function crowd_package_list(data) {
  var _url = '/crowd/package/list'
  return request({
    url: _url,
    method: 'get',
    data:data
  })
}

export function crowd_package_add(data) {
  var _url = '/crowd/package/add'
  return request({
    url: _url,
    method: 'post',
    data:data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
  })
}
export function crowd_package_edit(data) {
  var _url = '/crowd/package/edit'
  return request({
    url: _url,
    method: 'post',
    data:data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
  })
}
export function crowd_package_delete(data) {
  var _url = '/crowd/package/delete/' + data.id
  return request({
    url: _url,
    method: 'post',
    data:''
  })
}
export function crowd_package_detail(data) {
  var _url = '/crowd/package/detail/list'
  return request({
    url: _url,
    method: 'get',
    data:data
  })
}


// WEBPACK FOOTER //
// ./src/api/product/parent.js